import { render, staticRenderFns } from "./GatDateTimeEdit.vue?vue&type=template&id=96e30ae6&scoped=true"
import script from "./GatDateTimeEdit.vue?vue&type=script&lang=js"
export * from "./GatDateTimeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e30ae6",
  null
  
)

export default component.exports